export default __webpack_public_path__ + "static/media/banner.b474b73c.png";